import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const organization = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the organization.'),

    orgStructureLevelId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to OrgStructureLevel'),

    parentId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Organization'),

    orgStructureLevel: references('OrgStructureLevel', 'orgStructureLevelId'),

    parent: references('Organization', 'parentId'),

    children: hasMany('Organization', 'parentId'),

    positions: hasMany('Position', 'organizationId'),
  })
  .describe(
    'An organizational unit within the hierarchy, such as a specific division or team.',
  )
  .as('Organization');

export { organization as organizationSchema };
